import LangForeignWrapper from '@jaaluu/views/LangForeignWrapper.vue';
import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';

import Welcome from '@jaaluu/views/Welcome/Welcome.vue';
import { assertUniqueRoutes } from '@jaaluu/router/assertUniqueRoutes';
import { generateSpokeRoutes } from '@jaaluu/router/spokeRoutes';

const routes: RouteRecordRaw[] = [
    {
      path: '/welcome/:campaign',
      name: 'welcome-campaign',
      component: Welcome
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: Welcome
    },
    {
      path: '/intro',
      name: 'intro',
      component: () => import('@jaaluu/views/Intro.vue')
    },
    // Target-language spoke pages (e.g. "sprachzeitung-englisch") - generated
    // from data rather than hand-typed like the hub routes below, since
    // there are ~576 of them. See @jaaluu/router/spokeRoutes.ts.
    ...generateSpokeRoutes(),
    {
      path: '/sprachzeitung',
      name: 'sprachzeitung',
      component: () => import('@jaaluu/views/Landing/de/LanguageNewspaper.vue')
    },
    {
      path: '/periodico-de-idiomas',
      name: 'periodico',
      component: () => import('@jaaluu/views/Landing/es/LanguageNewspaper.vue')
    },
    {
      path: '/giornale-linguistico',
      name: 'giornale',
      component: () => import('@jaaluu/views/Landing/it/LanguageNewspaper.vue')
    },
    {
      path: '/journal-linguistique',
      name: 'journal',
      component: () => import('@jaaluu/views/Landing/fr/LanguageNewspaper.vue')
    },
    {
      path: '/jornal-linguistico',
      name: 'jornal',
      component: () => import('@jaaluu/views/Landing/pt/LanguageNewspaper.vue')
    },
    {
      path: '/gazeta-jezykowa',
      name: 'gazeta',
      component: () => import('@jaaluu/views/Landing/pl/LanguageNewspaper.vue')
    },
    {
      path: '/языковая-газета',
      name: 'gazeta-ru',
      component: () => import('@jaaluu/views/Landing/ru/LanguageNewspaper.vue')
    },
    {
      path: '/language-newspaper',
      name: 'newspaper',
      component: () => import('@jaaluu/views/Landing/en/LanguageNewspaper.vue')
    },
    {
      path: '/语言报纸',
      name: 'baozhi',
      component: () => import('@jaaluu/views/Landing/zh/LanguageNewspaper.vue')
    },
    {
      path: '/ki-sprachlehrer',
      name: 'ki-sprachlehrer',
      component: () => import('@jaaluu/views/Landing/de/AiChatTeacher.vue')
    },
    {
      path: '/AI语言老师',
      name: 'ai-yuyan-laoshi-zh',
      component: () => import('@jaaluu/views/Landing/zh/AiChatTeacher.vue')
    },
    {
      path: '/vokabeltrainer',
      name: 'vokabeltrainer',
      component: () => import('@jaaluu/views/Landing/de/VocabularyTrainer.vue')
    },
    {
      path: '/digitales-woerterbuch',
      name: 'digitales-woerterbuch',
      component: () => import('@jaaluu/views/Landing/de/DigitalDictionary.vue')
    },
    {
      path: '/ai-language-tutor',
      name: 'ai-language-tutor',
      component: () => import('@jaaluu/views/Landing/en/AiChatTeacher.vue')
    },
    {
      path: '/profesor-ia-idiomas',
      name: 'profesor-ia-idiomas',
      component: () => import('@jaaluu/views/Landing/es/AiChatTeacher.vue')
    },
    {
      path: '/professeur-ia-langues',
      name: 'professeur-ia-langues',
      component: () => import('@jaaluu/views/Landing/fr/AiChatTeacher.vue')
    },
    {
      path: '/insegnante-ia-lingue',
      name: 'insegnante-ia-lingue',
      component: () => import('@jaaluu/views/Landing/it/AiChatTeacher.vue')
    },
    {
      path: '/professor-ia-idiomas',
      name: 'professor-ia-idiomas',
      component: () => import('@jaaluu/views/Landing/pt/AiChatTeacher.vue')
    },
    {
      path: '/ии-репетитор',
      name: 'ii-repetitor-ru',
      component: () => import('@jaaluu/views/Landing/ru/AiChatTeacher.vue')
    },
    {
      path: '/nauczyciel-ai',
      name: 'nauczyciel-ai',
      component: () => import('@jaaluu/views/Landing/pl/AiChatTeacher.vue')
    },
    {
      path: '/digital-dictionary',
      name: 'digital-dictionary',
      component: () => import('@jaaluu/views/Landing/en/DigitalDictionary.vue')
    },
    {
      path: '/diccionario-digital',
      name: 'diccionario-digital',
      component: () => import('@jaaluu/views/Landing/es/DigitalDictionary.vue')
    },
    {
      path: '/dictionnaire-numerique',
      name: 'dictionnaire-numerique',
      component: () => import('@jaaluu/views/Landing/fr/DigitalDictionary.vue')
    },
    {
      path: '/dizionario-digitale',
      name: 'dizionario-digitale',
      component: () => import('@jaaluu/views/Landing/it/DigitalDictionary.vue')
    },
    {
      path: '/dicionario-digital',
      name: 'dicionario-digital',
      component: () => import('@jaaluu/views/Landing/pt/DigitalDictionary.vue')
    },
    {
      path: '/цифровой-словарь',
      name: 'cifrovoy-slovar-ru',
      component: () => import('@jaaluu/views/Landing/ru/DigitalDictionary.vue')
    },
    {
      path: '/电子词典',
      name: 'dianzi-cidian-zh',
      component: () => import('@jaaluu/views/Landing/zh/DigitalDictionary.vue')
    },
    {
      path: '/cyfrowy-slownik',
      name: 'cyfrowy-slownik',
      component: () => import('@jaaluu/views/Landing/pl/DigitalDictionary.vue')
    },
    {
      path: '/vocabulary-trainer',
      name: 'vocabulary-trainer',
      component: () => import('@jaaluu/views/Landing/en/VocabularyTrainer.vue')
    },
    {
      path: '/entrenador-de-vocabulario',
      name: 'entrenador-de-vocabulario',
      component: () => import('@jaaluu/views/Landing/es/VocabularyTrainer.vue')
    },
    {
      path: '/entraineur-de-vocabulaire',
      name: 'entraineur-de-vocabulaire',
      component: () => import('@jaaluu/views/Landing/fr/VocabularyTrainer.vue')
    },
    {
      path: '/allenatore-di-vocabolario',
      name: 'allenatore-di-vocabolario',
      component: () => import('@jaaluu/views/Landing/it/VocabularyTrainer.vue')
    },
    {
      path: '/treinador-de-vocabulario',
      name: 'treinador-de-vocabulario',
      component: () => import('@jaaluu/views/Landing/pt/VocabularyTrainer.vue')
    },
    {
      path: '/словарный-тренажёр',
      name: 'slovarnyy-trenazher-ru',
      component: () => import('@jaaluu/views/Landing/ru/VocabularyTrainer.vue')
    },
    {
      path: '/词汇训练器',
      name: 'cihui-xunlianqi-zh',
      component: () => import('@jaaluu/views/Landing/zh/VocabularyTrainer.vue')
    },
    {
      path: '/trener-slownictwa',
      name: 'trener-slownictwa',
      component: () => import('@jaaluu/views/Landing/pl/VocabularyTrainer.vue')
    },
    {
      path: '/natural-method',
      name: 'natural-method',
      component: () => import('@jaaluu/views/Landing/en/NaturalMethod.vue')
    },
    {
      path: '/natuerliche-methode',
      name: 'natuerliche-methode',
      component: () => import('@jaaluu/views/Landing/de/NaturalMethod.vue')
    },
    {
      path: '/metodo-natural',
      name: 'metodo-natural',
      component: () => import('@jaaluu/views/Landing/es/NaturalMethod.vue')
    },
    {
      path: '/methode-naturelle',
      name: 'methode-naturelle',
      component: () => import('@jaaluu/views/Landing/fr/NaturalMethod.vue')
    },
    {
      path: '/metodo-naturale',
      name: 'metodo-naturale',
      component: () => import('@jaaluu/views/Landing/it/NaturalMethod.vue')
    },
    {
      path: '/aprendizado-natural',
      name: 'aprendizado-natural',
      component: () => import('@jaaluu/views/Landing/pt/NaturalMethod.vue')
    },
    {
      path: '/естественный-метод',
      name: 'estestvennyy-metod-ru',
      component: () => import('@jaaluu/views/Landing/ru/NaturalMethod.vue')
    },
    {
      path: '/metoda-naturalna',
      name: 'metoda-naturalna',
      component: () => import('@jaaluu/views/Landing/pl/NaturalMethod.vue')
    },
    {
      path: '/自然教学法',
      name: 'ziran-jiaoxuefa',
      component: () => import('@jaaluu/views/Landing/zh/NaturalMethod.vue')
    },
    {
      path: '/einfache-texte-lesen',
      name: 'einfache-texte-lesen',
      component: () => import('@jaaluu/views/Landing/de/ReadText.vue')
    },
    {
      path: '/simple-texts',
      name: 'simple-texts',
      component: () => import('@jaaluu/views/Landing/en/ReadText.vue')
    },
    {
      path: '/textos-sencillos',
      name: 'textos-sencillos',
      component: () => import('@jaaluu/views/Landing/es/ReadText.vue')
    },
    {
      path: '/textes-simples',
      name: 'textes-simples',
      component: () => import('@jaaluu/views/Landing/fr/ReadText.vue')
    },
    {
      path: '/testi-semplici',
      name: 'testi-semplici',
      component: () => import('@jaaluu/views/Landing/it/ReadText.vue')
    },
    {
      path: '/textos-simples',
      name: 'textos-simples-pt',
      component: () => import('@jaaluu/views/Landing/pt/ReadText.vue')
    },
    {
      path: '/простые-тексты',
      name: 'prostye-teksty-ru',
      component: () => import('@jaaluu/views/Landing/ru/ReadText.vue')
    },
    {
      path: '/proste-teksty',
      name: 'proste-teksty',
      component: () => import('@jaaluu/views/Landing/pl/ReadText.vue')
    },
    {
      path: '/简单文本',
      name: 'jiandan-wenben-zh',
      component: () => import('@jaaluu/views/Landing/zh/ReadText.vue')
    },
    {
      path: '/reading-practice',
      name: 'reading-practice',
      component: () => import('@jaaluu/views/Landing/en/ReadingPractice.vue')
    },
    {
      path: '/leseuebung',
      name: 'leseuebung',
      component: () => import('@jaaluu/views/Landing/de/ReadingPractice.vue')
    },
    {
      path: '/practica-de-lectura',
      name: 'practica-de-lectura',
      component: () => import('@jaaluu/views/Landing/es/ReadingPractice.vue')
    },
    {
      path: '/pratique-de-lecture',
      name: 'pratique-de-lecture',
      component: () => import('@jaaluu/views/Landing/fr/ReadingPractice.vue')
    },
    {
      path: '/pratica-di-lettura',
      name: 'pratica-di-lettura',
      component: () => import('@jaaluu/views/Landing/it/ReadingPractice.vue')
    },
    {
      path: '/pratica-de-leitura',
      name: 'pratica-de-leitura',
      component: () => import('@jaaluu/views/Landing/pt/ReadingPractice.vue')
    },
    {
      path: '/cwiczenia-czytania',
      name: 'cwiczenia-czytania',
      component: () => import('@jaaluu/views/Landing/pl/ReadingPractice.vue')
    },
    {
      path: '/практика-чтения',
      name: 'praktika-chteniya-ru',
      component: () => import('@jaaluu/views/Landing/ru/ReadingPractice.vue')
    },
    {
      path: '/阅读练习',
      name: 'yuedu-lianxi-zh',
      component: () => import('@jaaluu/views/Landing/zh/ReadingPractice.vue')
    },
    {
      path: '/live-transcription',
      name: 'live-transcription',
      component: () => import('@jaaluu/views/Landing/en/Transcription.vue')
    },
    {
      path: '/live-transkription',
      name: 'live-transkription',
      component: () => import('@jaaluu/views/Landing/de/Transcription.vue')
    },
    {
      path: '/transcripcion-en-vivo',
      name: 'transcripcion-en-vivo',
      component: () => import('@jaaluu/views/Landing/es/Transcription.vue')
    },
    {
      path: '/transcription-en-direct',
      name: 'transcription-en-direct',
      component: () => import('@jaaluu/views/Landing/fr/Transcription.vue')
    },
    {
      path: '/trascrizione-dal-vivo',
      name: 'trascrizione-dal-vivo',
      component: () => import('@jaaluu/views/Landing/it/Transcription.vue')
    },
    {
      path: '/transcricao-ao-vivo',
      name: 'transcricao-ao-vivo',
      component: () => import('@jaaluu/views/Landing/pt/Transcription.vue')
    },
    {
      path: '/transkrypcja-na-zywo',
      name: 'transkrypcja-na-zywo',
      component: () => import('@jaaluu/views/Landing/pl/Transcription.vue')
    },
    {
      path: '/живая-транскрипция',
      name: 'zhivaya-transkriptsiya-ru',
      component: () => import('@jaaluu/views/Landing/ru/Transcription.vue')
    },
    {
      path: '/实时转录',
      name: 'shishi-zhuanlu-zh',
      component: () => import('@jaaluu/views/Landing/zh/Transcription.vue')
    },
    {
      path: '/video-object-detection',
      name: 'video-object-detection-landing',
      component: () => import('@jaaluu/views/Landing/en/VideoObjectDetection.vue')
    },
    {
      path: '/video-objekterkennung',
      name: 'video-objekterkennung',
      component: () => import('@jaaluu/views/Landing/de/VideoObjectDetection.vue')
    },
    {
      path: '/deteccion-de-objetos',
      name: 'deteccion-de-objetos',
      component: () => import('@jaaluu/views/Landing/es/VideoObjectDetection.vue')
    },
    {
      path: '/detection-objets-video',
      name: 'detection-objets-video',
      component: () => import('@jaaluu/views/Landing/fr/VideoObjectDetection.vue')
    },
    {
      path: '/rilevamento-oggetti-video',
      name: 'rilevamento-oggetti-video',
      component: () => import('@jaaluu/views/Landing/it/VideoObjectDetection.vue')
    },
    {
      path: '/deteccao-de-objetos',
      name: 'deteccao-de-objetos',
      component: () => import('@jaaluu/views/Landing/pt/VideoObjectDetection.vue')
    },
    {
      path: '/rozpoznawanie-obiektow',
      name: 'rozpoznawanie-obiektow',
      component: () => import('@jaaluu/views/Landing/pl/VideoObjectDetection.vue')
    },
    {
      path: '/распознавание-объектов',
      name: 'raspoznavanie-obektov-ru',
      component: () => import('@jaaluu/views/Landing/ru/VideoObjectDetection.vue')
    },
    {
      path: '/视频物体识别',
      name: 'shipin-wuti-shibie-zh',
      component: () => import('@jaaluu/views/Landing/zh/VideoObjectDetection.vue')
    },
    {
      path: '/learn-a-language',
      name: 'learn-a-language',
      component: () => import('@jaaluu/views/Landing/en/LearnLanguage.vue')
    },
    {
      path: '/sprachen-lernen',
      name: 'sprachen-lernen',
      component: () => import('@jaaluu/views/Landing/de/LearnLanguage.vue')
    },
    {
      path: '/aprender-idiomas',
      name: 'aprender-idiomas',
      component: () => import('@jaaluu/views/Landing/es/LearnLanguage.vue')
    },
    {
      path: '/apprendre-une-langue',
      name: 'apprendre-une-langue',
      component: () => import('@jaaluu/views/Landing/fr/LearnLanguage.vue')
    },
    {
      path: '/imparare-una-lingua',
      name: 'imparare-una-lingua',
      component: () => import('@jaaluu/views/Landing/it/LearnLanguage.vue')
    },
    {
      path: '/aprender-linguas',
      name: 'aprender-linguas',
      component: () => import('@jaaluu/views/Landing/pt/LearnLanguage.vue')
    },
    {
      path: '/nauka-jezykow',
      name: 'nauka-jezykow',
      component: () => import('@jaaluu/views/Landing/pl/LearnLanguage.vue')
    },
    {
      path: '/изучение-языков',
      name: 'izuchenie-yazykov-ru',
      component: () => import('@jaaluu/views/Landing/ru/LearnLanguage.vue')
    },
    {
      path: '/学习语言',
      name: 'xuexi-yuyan-zh',
      component: () => import('@jaaluu/views/Landing/zh/LearnLanguage.vue')
    },
    {
      path: '/:langForeign',
      component: LangForeignWrapper,
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('@jaaluu/views/Home/Home.vue')
        },
        {
          path: 'search',
          name: 'search',
          component: () => import('@jaaluu/views/GlobalSearch/GlobalSearch.vue')
        },
        {
          path: 'grammar/chapter/:chapterNumber',
          name: 'grammar-lesson',
          component: () => import('@jaaluu/views/GrammarLesson/GrammarLesson.vue')
        },
        {
          path: 'feeds/:topic',
          name: 'feed-list',
          component: () => import('@jaaluu/views/Lists/FeedList/FeedList.vue')
        },
        {
          path: 'feeds/:topic/:id',
          name: 'feed-details',
          component: () => import('@jaaluu/views/Details/FeedDetails/FeedDetails.vue')
        },
        {
          path: 'videos/:channelId',
          name: 'video-list',
          component: () => import('@jaaluu/views/Lists/VideoList/VideoList.vue')
        },
        {
          path: 'videos/:channelId/:id',
          name: 'video-details',
          component: () => import('@jaaluu/views/Details/VideoDetails/VideoDetails.vue')
        },
        {
          path: 'wikipedia',
          name: 'wikipedia-list',
          component: () => import('@jaaluu/views/Lists/WikipediaList/WikipediaList.vue')
        },
        {
          path: 'wikipedia/:title',
          name: 'wikipedia-details',
          component: () => import('@jaaluu/views/Details/WikipediaDetails/WikipediaDetails.vue')
        },
        {
          path: 'kids_lexicon',
          name: 'kids-lexicon-list',
          component: () => import('@jaaluu/views/Lists/KlexikonList/KlexikonList.vue')
        },
        {
          path: 'kids_lexicon/:title',
          name: 'kids-lexicon-details',
          component: () => import('@jaaluu/views/Details/KlexikonDetails/KlexikonDetails.vue')
        },
        {
          path: 'books',
          name: 'books-list',
          component: () => import('@jaaluu/views/Lists/BooksList/BooksList.vue')
        },
        {
          path: 'books/:id',
          name: 'book-details',
          component: () => import('@jaaluu/views/Details/BookDetails/BookDetails.vue')
        },
        {
          path: 'category/:categoryType/',
          name: 'category-list-main',
          component: () => import('@jaaluu/views/Lists/CategoryList/CategoryListMain.vue')
        },
        {
          path: 'category/:categoryType/:category',
          name: 'category-list-sub',
          component: () => import('@jaaluu/views/Lists/CategoryList/CategoryListSub.vue')
        },
        {
          path: 'category/conversations/:mainCategory/:subCategory',
          name: 'conversation-details',
          component: () =>
            import(
              '@jaaluu/views/Details/CategoryDetails/ConversationDetails/ConversationDetails.vue'
            )
        },
        {
          path: 'category/write/:mainCategory/:subCategory',
          name: 'write-details',
          component: () => import('@jaaluu/views/Details/WriteDetails/WriteDetails.vue')
        },
        {
          path: 'course/status',
          name: 'course-status',
          component: () => import('@jaaluu/views/Details/CourseStatusInfo/CourseStatusInfo.vue')
        },
        {
          path: 'course/story/:storyIdx',
          name: 'course',
          component: () => import('@jaaluu/views/Details/CoursePartDetails/CourseStory.vue')
        },
        {
          path: 'course/vocabularies/:storyIdx',
          name: 'vocabularies-details',
          component: () => import('@jaaluu/views/Details/CoursePartDetails/CourseVocabularies.vue')
        },
        {
          path: 'category/:categoryType/:mainCategory/:subCategory',
          name: 'category-details',
          component: () => import('@jaaluu/views/Details/CategoryDetails/CategoryDetails.vue')
        },
        {
          path: 'vocabulary',
          name: 'vocabulary',
          component: () => import('@jaaluu/views/Vocabulary.vue')
        },
        {
          path: 'jokes',
          name: 'jokes',
          component: () => import('@jaaluu/views/Jokes.vue')
        },
        {
          path: 'live-conversations',
          name: 'live-conversation-list',
          component: () =>
            import('@jaaluu/views/Lists/LiveConversationList/LiveConversationList.vue')
        },
        {
          path: 'live-conversations/:id',
          name: 'live-conversation-details',
          component: () =>
            import('@jaaluu/views/Details/LiveConversationDetails/LiveConversationDetails.vue')
        },
        {
          path: 'transcription',
          name: 'transcription',
          component: () => import('@jaaluu/views/Transcription.vue')
        },
        {
          path: 'video-object-detection',
          name: 'video-object-detection',
          component: () => import('@jaaluu/views/VideoObjectDetection.vue')
        },
        {
          path: 'custom-vocabulary',
          name: 'custom-vocabulary',
          component: () => import('@jaaluu/views/CustomVocabulary.vue')
        },
        {
          path: 'custom-vocabulary/:id',
          name: 'custom-vocabulary-details',
          component: () => import('@jaaluu/views/CustomVocabularyDetails.vue')
        },
        {
          path: 'favorites/words/:type',
          name: 'favorite-words',
          component: () => import('@jaaluu/views/Favorites/FavoriteWords.vue')
        },
        {
          path: 'favorites/urls',
          name: 'favorite-urls',
          component: () => import('@jaaluu/views/Favorites/FavoriteUrls.vue')
        },
        {
          path: 'favorites/wordmaps',
          name: 'favorite-wordmaps',
          component: () => import('@jaaluu/views/Favorites/FavoriteWordmaps.vue')
        },
        {
          path: 'chat',
          name: 'chat',
          component: () => import('@jaaluu/views/Details/ChatDetails/ChatDetails.vue')
        },
        {
          path: 'custom',
          name: 'custom',
          component: () => import('@jaaluu/views/Details/CustomTextDetails/CustomTextDetails.vue')
        },
        {
          path: 'about',
          name: 'about',
          component: () => import('@jaaluu/views/Footer/About.vue')
        },
        {
          path: 'support',
          name: 'support',
          component: () => import('@jaaluu/views/Footer/Support.vue')
        },
        {
          path: 'disclaimer',
          name: 'disclaimer',
          component: () => import('@jaaluu/views/Footer/Disclaimer.vue')
        },
        {
          path: 'privacy-policy',
          name: 'privacy-policy',
          component: () => import('@jaaluu/views/Footer/PrivacyPolicy.vue')
        },
        {
          path: 'impressum',
          name: 'impressum',
          component: () => import('@jaaluu/views/Footer/Impressum.vue')
        },
        {
          path: 'licence',
          name: 'licence',
          component: () => import('@jaaluu/views/Footer/Licence.vue')
        },
        {
          path: 'not_found',
          name: 'not-found',
          component: () => import('@jaaluu/views/NotFound.vue')
        },
        {
          path: 'learn/flipcards',
          name: 'learn-flipcards',
          component: () => import('@jaaluu/views/FlipCards.vue')
        },
        {
          path: 'learn/sentence-or-def-matcher',
          name: 'learn-sentence-or-def-matcher',
          component: () => import('@jaaluu/views/Train/SentenceOrDefMatcher.vue')
        },
        {
          path: 'wordmap/:word',
          name: 'wordmap',
          component: () => import('@jaaluu/views/Wordmap/Wordmap.vue')
        },
        {
          path: 'learn/exercises',
          name: 'learn-exercises',
          component: () => import('@jaaluu/views/Train/Test.vue')
        },
        {
          path: 'learn/repeat',
          name: 'learn-repeat',
          component: () => import('@jaaluu/views/Train/RepeatFavs.vue')
        },
        {
          path: 'learn/train-questions',
          name: 'learn-train-questions',
          component: () => import('@jaaluu/views/Details/CoursePartDetails/CourseTrainQuestions.vue')
        },
        {
          path: 'learn/gap-text/:storyIdx',
          name: 'learn-gap-text',
          component: () => import('@jaaluu/views/Train/GapTextDetails.vue')
        },
        {
          path: 'auto-text',
          name: 'auto-text',
          component: () => import('@jaaluu/views/AutoText.vue')
        },
        {
          path: 'add-auto-text',
          name: 'add-auto-text',
          component: () => import('@jaaluu/views/AddAutoText.vue')
        },


        /*
    {
      path: "/welcome",
      name: "welcome",
      component: Landing,
    },
    {
      path: "/registrate",
      name: "registrate",
      component: Registrate,
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/videos/:videoId",
      name: "video",
      component: Video,
    },
    {
      path: "/videos",
      name: "videos",
      component: Videos,
    },
    {
      path: "/articles/:title",
      name: "article-details",
      component: Article,
    },
    {
      path: "/news",
      name: "news",
      component: News,
    },
    {
      path: "/news/:title",
      name: "news-details",
      component: NewsDetails,
    },
    {
      path: "/categories/:categoryType",
      name: "unit-categories",
      component: UnitCategories,
    },
    {
      path: "/categories/:categoryType/:subCategoryId",
      name: "unit-details",
      component: UnitDetails,
    },
    {
      path: "/admin/login",
      name: "admin-login",
      component: AdminLogin,
    },
    {
      path: "/admin",
      name: "admin-home",
      component: AdminHome,
    } */
      ]
    }
];

assertUniqueRoutes(routes);

const router = createRouter({
  history: createWebHistory((import.meta as any).env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Always scroll to the top of the page on navigation
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});

/* 
const ADMIN_LOGIN_PATH = "/admin/login";
router.beforeEach(async (to, from, next) => {
  // admin
  if (to.path !== ADMIN_LOGIN_PATH && to.path.startsWith("/admin")) {
    const token = localStorage.getItem("token");
    if (!token) {
      next({ path: ADMIN_LOGIN_PATH });
    } else {
      const res = await jaaluuApi.get("/validate-token").catch((error: any) => {
        console.warn("Could not validate token", error);
        next({ path: ADMIN_LOGIN_PATH });
      });
    }
  }
  next();
});
*/

export default router;
